import appReport from "../../views/appSettings/report.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("report", {
    url: "report/:id",
    parent: "app",
    views: {
      view: {
        template: appReport,
      },
    },
    reloadOnSearch: false,
    data: { title: "Report" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/report/report.urls.js